const PAYMENT_STATUSES = {
    1: 'PAID',
    2: 'PENDING',
    3: 'FAILED',
};

/**
 * Transaction status is stored as 1, 2, or 3 and exposed to the page as PAID, PENDING, or FAILED.
 * Accept either form. An unknown value is shown as stored.
 */
export function paymentStatusLabel(status, paymentStatuses) {
    if (status == null || status === '') {
        return 'YET TO PAY';
    }

    const provided = paymentStatuses && typeof paymentStatuses === 'object' ? paymentStatuses : {};
    const map = Object.keys(provided).length ? provided : PAYMENT_STATUSES;
    const normalized = String(status).toUpperCase();
    const named = Object.values(map).find((label) => String(label).toUpperCase() === normalized);

    if (named) {
        return named;
    }

    if (Object.prototype.hasOwnProperty.call(map, status)) {
        return map[status];
    }

    if (Object.prototype.hasOwnProperty.call(map, String(status))) {
        return map[String(status)];
    }

    return String(status);
}
